var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterialActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86761 1.67242L4.12511 3.07492C3.26261 3.39742 2.55762 4.41741 2.55762 5.33991V10.9124C2.55762 11.7974 3.14263 12.9599 3.85513 13.4924L7.08012 15.8999C8.13762 16.6949 9.8776 16.6949 10.9351 15.8999L14.1601 13.4924C14.8726 12.9599 15.4576 11.7974 15.4576 10.9124V5.33991C15.4576 4.41741 14.7526 3.39742 13.8901 3.07492L10.1476 1.67242C9.51011 1.43992 8.49011 1.43992 7.86761 1.67242Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99977 8.19006C8.96977 8.19006 8.93227 8.19006 8.90227 8.19006C8.19727 8.16756 7.63477 7.58256 7.63477 6.87006C7.63477 6.14256 8.22727 5.55005 8.95477 5.55005C9.68227 5.55005 10.2748 6.14256 10.2748 6.87006C10.2673 7.59006 9.70477 8.16756 8.99977 8.19006Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50729 10.29C6.78729 10.77 6.78729 11.5575 7.50729 12.0375C8.32479 12.585 9.66729 12.585 10.4848 12.0375C11.2048 11.5575 11.2048 10.77 10.4848 10.29C9.67479 9.74252 8.33229 9.74252 7.50729 10.29Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialActiveIcon);
export default __webpack_public_path__ + "static/media/material_active_icon.155810b6eb43a1e3177acad07eb101ff.svg";
export { ForwardRef as ReactComponent };